import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../guards/auth.guard';
import { DriverJobReportsComponent } from './driver-job-reports.component';

const routes: Routes = [
  { path: '', component: DriverJobReportsComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DriverReportsRoutingModule { }
